import { financialActionKey, financialCommandPath } from "./financial-actions.ts"
import type { UserRoute } from "./routes.ts"

export type RouteAction = {
  readonly body: Readonly<Record<string, string | boolean>>
  readonly endpoint: string
  readonly idempotencyKey?: string
  readonly label: string
  readonly receipt: { readonly kind: "static"; readonly routeId: UserRoute["id"] } | { readonly kind: "generated-resource"; readonly routeId: UserRoute["id"] } | { readonly kind: "owned-resource"; readonly resourceId: string; readonly routeId: UserRoute["id"] }
}

const resource = (search: URLSearchParams, fallback: string): string => search.get("resourceId") ?? search.get("quoteId") ?? fallback

export const routeAction = (route: UserRoute, pathname: string, search: URLSearchParams): RouteAction | null => {
  const resourceId = resource(search, pathname.split("/").at(-1) ?? "00000000-0000-4000-8000-000000000000")
  switch (route.id) {
    case "APP-AUTH-002":
      return { body: { agreed: true, channel: "WEB" }, endpoint: "/identity/consents", label: "필수 항목에 동의", receipt: { kind: "static", routeId: "APP-AUTH-003" } }
    case "APP-AUTH-003":
      return { body: { credential: search.get("entry") ?? "", consent: true }, endpoint: "/entry/consent-link", label: "계정 연결", receipt: { kind: "generated-resource", routeId: "APP-TRF-001" } }
    case "APP-TRF-001":
      return { body: { quoteId: resourceId }, endpoint: financialCommandPath.conversionConfirm, idempotencyKey: financialActionKey({ kind: "conversion.confirm", resourceId }), label: "전환 확정", receipt: { kind: "owned-resource", resourceId, routeId: "APP-TRF-002" } }
    case "APP-TRF-002":
      return { body: { next: "/transfer/success" }, endpoint: "/web/continue", label: "전환 결과 확인", receipt: { kind: "static", routeId: "APP-TRF-003" } }
    case "APP-SHOP-003":
      return { body: { productId: pathname.split("/").at(-1) ?? "" }, endpoint: financialCommandPath.redemptionPrepare, idempotencyKey: financialActionKey({ kind: "redemption.prepare", resourceId }), label: "교환 준비", receipt: { kind: "owned-resource", resourceId, routeId: "APP-RDM-001" } }
    case "APP-RDM-001":
      return { body: { quoteId: resourceId }, endpoint: financialCommandPath.redemptionConfirm, idempotencyKey: financialActionKey({ kind: "redemption.confirm", resourceId }), label: "교환 확정", receipt: { kind: "owned-resource", resourceId, routeId: "APP-RDM-002" } }
    case "APP-VERIFY-001":
      return { body: { confirmed: true }, endpoint: "/identity/phone", label: "이 번호로 받기", receipt: { kind: "generated-resource", routeId: "APP-RDM-001" } }
    case "APP-RDM-002":
      return { body: { next: "/redeem/success" }, endpoint: "/web/continue", label: "교환 결과 확인", receipt: { kind: "static", routeId: "APP-RDM-003" } }
    case "APP-VCH-002":
      return null
    case "APP-DEL-001":
      return { body: { reasonCode: "USER_REQUEST" }, endpoint: "/identity/deletion", label: "탈퇴 요청", receipt: { kind: "static", routeId: "APP-AUTH-001" } }
    default:
      return null
  }
}
